import { createSlice } from "@reduxjs/toolkit";

const getInitialCartCount = () => {
  try {
    const cartItem = JSON.parse(localStorage.getItem("cart"));
    if (Array.isArray(cartItem)) {
      return cartItem.reduce((accumulator, currentValue) => accumulator + Number(currentValue.qty || 0), 0);
    }
  } catch (e) {
    console.error("Error parsing cart from localStorage", e);
  }
  return 0;
};

export const cartSlice = createSlice({
  name: "cart",
  initialState: getInitialCartCount(),
  reducers: {
    cartLength: (state) => {
      const cartItem = JSON.parse(localStorage.getItem("cart"));
      if (Array.isArray(cartItem)) {
        return cartItem.reduce((accumulator, currentValue) => accumulator + Number(currentValue.qty || 0), 0);
      }
      return 0;
    }
  }
});

export const { cartLength } = cartSlice.actions;
export default cartSlice.reducer;
